export default __webpack_public_path__ + "static/media/AdsClick.d6e76443.svg";